import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconDocumentation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "#fff",
	viewBox: "0 0 25.114 20.928",
	className: "pageIcon",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_3462",
		"data-name": "Group 3462",
		transform: "translate(-5 -2)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Path_6437",
			"data-name": "Path 6437",
			d: "M27.324,4.79H17.557L15.59,2.823A2.8,2.8,0,0,0,13.609,2H7.79A2.787,2.787,0,0,0,5.014,4.79L5,20.138a2.8,2.8,0,0,0,2.79,2.79H27.324a2.8,2.8,0,0,0,2.79-2.79V7.581A2.8,2.8,0,0,0,27.324,4.79ZM23.138,17.348H11.976a.7.7,0,0,1-.558-1.116l1.925-2.553a.692.692,0,0,1,1.116,0l1.7,2.274,3.1-4.144a.692.692,0,0,1,1.116,0L23.7,16.231A.7.7,0,0,1,23.138,17.348Z"
		})
	})
});
export { SvgIconDocumentation as ReactComponent };
